/**
 * @flow
 * @relayHash 4a42bd8a102b1647022e7e7e61ded02e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type setThankYouEmailHourInput = {|
  id: string,
  hour: number,
|};
export type setThanksMailHourMutationVariables = {|
  input: setThankYouEmailHourInput
|};
export type setThanksMailHourMutationResponse = {|
  +setThankYouEmailHour: ?{|
    +hyevent: ?{|
      +id: string,
      +thankYouEmailHour: ?number,
    |}
  |}
|};
export type setThanksMailHourMutation = {|
  variables: setThanksMailHourMutationVariables,
  response: setThanksMailHourMutationResponse,
|};
*/


/*
mutation setThanksMailHourMutation(
  $input: setThankYouEmailHourInput!
) {
  setThankYouEmailHour(input: $input) {
    hyevent {
      id
      thankYouEmailHour
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "setThankYouEmailHourInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setThankYouEmailHour",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "setThankYouEmailHourPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thankYouEmailHour",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "setThanksMailHourMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "setThanksMailHourMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "setThanksMailHourMutation",
    "id": null,
    "text": "mutation setThanksMailHourMutation(\n  $input: setThankYouEmailHourInput!\n) {\n  setThankYouEmailHour(input: $input) {\n    hyevent {\n      id\n      thankYouEmailHour\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2701d313c3482e2b960b0327a403019c';
module.exports = node;
